import sys from '@truckdown/jsclient';
import * as icons from '@truckdown/jsclient/icons';
import * as apis from '@truckdown/jsclient/apis';

import * as locations from '@truckdown/locations';
import { ILocationsUtilities } from '../Services/ILocationsUtilities';

import { defineComponent, ref, computed, onMounted, onUnmounted, nextTick, watch, inject } from 'vue';

////TODO: symlink error
//import { LocationStatus } from "@truckdown/app-locations/node_modules/@truckdown/locations/LocationStatus";

const userInfo = computed(() => {
    return {
        isAuth: sys.framework.context.isAuthenticated(),
        isFleet: sys.framework.context.isInRole(apis.framework.SecurityConstants.Roles.FleetUserRole)
    };
});

export default defineComponent({
    props: {

    },
    setup: function (props, ctx) {
        const isLoaded = ref<boolean>(false);
        const isLoading = ref<boolean>(false);

        const query_type = ref<string>('user');

        const total = ref<number>(0);
        const history = ref<locations.ServiceTransaction[]>([]);

        const getDetails = function (transaction: locations.ServiceTransaction) {
            var messages: string[] = [];

            var createdMessage = transaction.type == locations.ServiceTransactionType.Request ? 'Request submitted by ' : 'Numbers shown by ';
            messages.push(createdMessage + transaction.users[0].user + ' on ' + new Date(transaction.users[0].updated).toLocaleDateString("en-US", {
                weekday: 'short',
                month: 'short',
                day: '2-digit',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
            }));

            if (transaction.lastUpdated != transaction.users[0].updated) {
                messages.push('Last updated by ' + transaction.users[transaction.users.length - 1].user + ' on ' + new Date(transaction.lastUpdated).toLocaleDateString("en-US", {
                    weekday: 'short',
                    month: 'short',
                    day: '2-digit',
                    year: 'numeric',
                    hour: '2-digit',
                    minute: '2-digit'
                }));
            }

            return messages;
        }

        const viewDetails = function (transaction: locations.ServiceTransaction) {
            let name = encodeURIComponent(transaction.listing.name.replace(/ /g, '_').toLowerCase());
            let url = '/search/view-detail/' + name + '/' + transaction.locationId;
            window.location.href = url;
        }

        const getMoreModel = function (): locations.GetTransactionsModel {
            if (history.value.length == 0) {
                return {};
            }

            let lastRec: locations.ServiceTransaction = history.value[history.value.length - 1];

            let dt: Date | undefined = undefined;
            if (lastRec?.lastUpdated) {
                dt = new Date(lastRec.lastUpdated);
            }

            return {
                showAll: (query_type.value == 'account'),
                lastId: lastRec?.id,
                lastModified: dt
            };
        }

        const loadMore = async function () {
            if (!isLoading.value) {
                isLoading.value = true;

                try {
                    let service = sys.framework.getRequiredService<locations.IServiceTransactionManager>('IServiceTransactionManager');
                    let model = getMoreModel();
                    var results = await service.getTransactions(model);
                    total.value = results.count;
                    history.value = history.value.concat(results.results);
                    sys.events.emit('set-call-history-count', results.count);
                } catch (err) {
                    console.log(err);
                    total.value = 0;
                    history.value = [];
                } finally {
                    isLoading.value = false;
                }
            }
        }

        const displayText = computed(() => {
            if (isLoaded.value && total.value > 0) {
                let plural = 's';
                if (history.value.length == 1) {
                    plural = '';
                }

                return 'Displaying ' + history.value.length + ' Result' + plural + ' out of ' + total.value;
            }
            return '';
        });

        const showMore = computed(() => {
            if (!isLoaded.value) {
                return false;
            }

            if (!userInfo.value.isFleet) {
                return false;
            }

            return total.value > history.value.length;
        });

        const loadHistory = async function () {
            if (!isLoading.value) {
                isLoading.value = true;

                try {
                    let service = sys.framework.getRequiredService<locations.IServiceTransactionManager>('IServiceTransactionManager');
                    let model: locations.GetTransactionsModel = {
                        showAll: (query_type.value == 'account')
                    }
                    var results = await service.getTransactions(model);
                    total.value = results.count;
                    history.value = results.results;
                    sys.events.emit('set-call-history-count', results.count);
                } catch (err) {
                    console.log(err);
                    total.value = 0;
                    history.value = [];
                } finally {
                    isLoading.value = false;
                }
            }
        }

        const getUrl = function (path: string) {
            let currentUrl = window.location.pathname + window.location.search + window.location.hash;
            return path + '?returnUrl=' + encodeURIComponent(currentUrl);
        }

        onMounted(async () => {
            await loadHistory();
            isLoaded.value = true;

            sys.events.on('refresh-call-history', async function () {
                await loadHistory();
            });
        });

        watch(query_type, async function (newVal: string, oldVal: string) {
            if (isLoading.value) {
                query_type.value = oldVal;
            } else {
                await loadHistory();
            }
        });

        return {
            userInfo,
            isLoaded,
            isLoading,
            total,
            history,
            displayText,
            getDetails,
            showMore,
            viewDetails,
            loadMore,
            query_type,
            getUrl
        };
    }
});
